//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const changelogRoutes = [
  {
    path: i18n.global.t('routes.changelog.changelog'),
    name: Routes.CHANGELOG_LIST,
    component: () => import('@/components/changelog/ChangelogList.vue'),
    meta: {
      title: i18n.global.t('titles.changelog.changelog'),
      active: 'changelog',
      roles: [Permissions.ROLE_CHANGELOG_INDEX],
    },
  },
  {
    path: i18n.global.t('routes.changelog.changelogCreate'),
    name: Routes.CHANGELOG_CREATE,
    component: () => import('@/components/changelog/ChangelogCreate.vue'),
    meta: {
      title: i18n.global.t('titles.changelog.changelogCreate'),
      active: 'changelog',
      roles: [Permissions.ROLE_CHANGELOG_CREATE],
    },
  },
  {
    path: i18n.global.t('routes.changelog.changelogEdit'),
    name: Routes.CHANGELOG_EDIT,
    component: () => import('@/components/changelog/ChangelogEdit.vue'),
    meta: {
      title: i18n.global.t('titles.changelog.changelogEdit'),
      active: 'changelog',
      roles: [Permissions.ROLE_CHANGELOG_EDIT],
    },
  },
  {
    path: i18n.global.t('routes.changelog.whatsNew'),
    name: Routes.WHATS_NEW,
    component: () => import('@/components/changelog/WhatsNew.vue'),
    meta: {
      title: i18n.global.t('titles.changelog.whatsNew'),
    },
  },
];
